<i18n
  src="@/locales/views/agro_exporter/production/basic_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n
  src="@/locales/components/views/agro_exporter/production/query_container_export/exportation_status.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-chart-pie"></i><span class="space-icon"></span>
      {{ $t("labels.summary_title") }}
    </h1>
    <div class="bg-white rounded-lg shadow p-6 -scroll mt-6">
      <div class="grid grid-cols-5 gap-4 mt-4">
        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p class="text-gray-600">Contenedores</p>
          <p class="text-2xl font-bold">
            {{ summary.total_containers }}
          </p>
        </div>

        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p class="text-gray-600">Exportaciones</p>
          <p class="text-2xl font-bold">
            {{ summary.total_exportations }}
          </p>
        </div>

        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p class="text-gray-600">Proveedores</p>
          <p class="text-2xl font-bold">
            {{ summary.total_providers }}
          </p>
        </div>

        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p class="text-gray-600">Clientes</p>
          <p class="text-2xl font-bold">
            {{ summary.total_clients }}
          </p>
        </div>

        <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p class="text-gray-600">Puertos de Destino</p>
          <p class="text-2xl font-bold">
            {{ summary.total_ports }}
          </p>
        </div>
      </div>

      <!-- Distribuciones detalladas -->
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        <div class="p-5 bg-white rounded-lg shadow">
          <h4
            class="mb-4 text-base font-semibold text-gray-800 border-b-2 border-gray-100 pb-3"
          >
            Contenedores por Proveedor
          </h4>
          <div class="flex flex-col gap-3">
            <div
              v-if="summary.containers_by_provider?.length === 0"
              class="text-center py-6 text-gray-400 italic"
            >
              Sin datos
            </div>
            <div
              v-for="item in summary.containers_by_provider"
              :key="item.id"
              class="flex justify-between items-center p-3 bg-gray-50 rounded border-l-4 border-lime-500 hover:bg-gray-100 transition-colors"
            >
              <span class="text-sm font-medium text-gray-700">{{
                item.name
              }}</span>
              <span class="text-md font-semibold text-lime-700">{{
                item.count
              }}</span>
            </div>
          </div>
        </div>

        <div class="p-5 bg-white rounded-lg shadow">
          <h4
            class="mb-4 text-base font-semibold text-gray-800 border-b-2 border-gray-100 pb-3"
          >
            Contenedores por Cliente
          </h4>
          <div class="flex flex-col gap-3">
            <div
              v-if="summary.containers_by_client?.length === 0"
              class="text-center py-6 text-gray-400 italic"
            >
              Sin datos
            </div>
            <div
              v-for="item in summary.containers_by_client"
              :key="item.id"
              class="flex justify-between items-center p-3 bg-gray-50 rounded border-l-4 border-lime-500 hover:bg-gray-100 transition-colors"
            >
              <span class="text-sm font-medium text-gray-700">{{
                item.name
              }}</span>
              <span class="text-md font-semibold text-lime-700">{{
                item.count
              }}</span>
            </div>
          </div>
        </div>

        <div class="p-5 bg-white rounded-lg shadow">
          <h4
            class="mb-4 text-base font-semibold text-gray-800 border-b-2 border-gray-100 pb-3"
          >
            Contenedores por Puerto de Destino
          </h4>
          <div class="flex flex-col gap-3">
            <div
              v-if="summary.containers_by_port?.length === 0"
              class="text-center py-6 text-gray-400 italic"
            >
              Sin datos
            </div>
            <div
              v-for="item in summary.containers_by_port"
              :key="item.id"
              class="flex justify-between items-center p-3 bg-gray-50 rounded border-l-4 border-lime-500 hover:bg-gray-100 transition-colors"
            >
              <span class="text-sm font-medium text-gray-700">{{
                item.name
              }}</span>
              <span class="text-md font-semibold text-lime-700">{{
                item.count
              }}</span>
            </div>
          </div>
        </div>

        <div class="p-5 bg-white rounded-lg shadow">
          <h4
            class="mb-4 text-base font-semibold text-gray-800 border-b-2 border-gray-100 pb-3"
          >
            Contenedores por tipo de envío
          </h4>
          <div class="flex flex-col gap-3">
            <div
              v-if="summary.containers_by_export_type?.length === 0"
              class="text-center py-6 text-gray-400 italic"
            >
              Sin datos
            </div>
            <div
              v-for="item in summary.containers_by_export_type"
              :key="item.id"
              class="flex justify-between items-center p-3 bg-gray-50 rounded border-l-4 border-lime-500 hover:bg-gray-100 transition-colors"
            >
              <span class="text-sm font-medium text-gray-700">
                {{ item.name == "sea" ? "Marítimo" : "Aéreo" }}
              </span>
              <span class="text-md font-semibold text-lime-700">
                {{ item.count }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowProcessSummary",
  props: {
    summary: {}
  }
};
</script>
